// Module
var code = "<h2 id=\"repayment-plans\">Repayment Plans</h2> <p>Exploring other repayment plans may help if you are having difficulty making your monthly payment.</p> ";
// Exports
export default code;